export default {
  header: {
    signIn: '로그인',
    signUp: '가입'
  },
  userMenu: {
    wallet: '지갑',
    withdraw: '출금',
    transaction: '거래 내역',
    myBet: '내 베팅',
    rollover: '롤오버',
    vault: '금고',
    profile: '프로필',
    settings: '설정',
    signOut: '로그아웃',
    signOutTitle: '로그아웃',
    signOutContent: '보상과 스릴 넘치는 게임으로 가득한 세계를 탐험하세요!',
    signOutConfirm: '로그아웃',
    cancel: '취소'
  }
};
